module.exports = __webpack_public_path__ + "img/IMG_20211228_174817491.4a3efacc.jpg";